<app-value-analysis>
  <app-action-buttons (resetAll)="resetAll()" (saveToSpaces)="openSaveToSpaces()"></app-action-buttons>
</app-value-analysis>
